
import {mapActions, mapState} from 'vuex';

import { required } from 'vuelidate/lib/validators';

import Button from '@/components/elements/Button';
import CustomInput from '@/components/elements/CustomInput';
import Spinner from '~/components/elements/LoaderSpinner';
import CustomRate from '~/components/elements/CustomRate';
import CustomDropzone from '~/components/elements/CustomDropzone';

export default {
  name: 'AddNewReview',
  components: {
    CustomDropzone,
    CustomRate,
    Spinner,
    CustomInput,
    Button,
  },

  validations: {
    rating: {
      required,
    },
    body: {
      required,
    },
  },

  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    itemCode: {
      type: String,
      required: true,
    },
    itemType: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      body: '',
      rating: null,
      pros: '',
      cons: '',
      files: [],
      dropzoneOptions: {
        accept: '.jpeg,.jpg,.webp,.png,.mp4,.mpeg',
        fileSize: 20000,
      },
    };
  },

  computed: {
    ...mapState('productReviews', ['isLoading']),
    countOptions() {
      const numbers = Array.from({ length: 6 }, (_, i) => i);
      return numbers.map((number) => ({ id: number, title: number, value: number }));
    },

    isBodyError() {
      return this.$v.body.$dirty && this.$v.body.$invalid;
    },

    isRatingError() {
      return this.$v.rating.$dirty && this.$v.rating.$invalid;
    },
  },

  methods: {
    ...mapActions({
      createReview: 'productReviews/createReview',
    }),
    successUploadPhoto(_, fileURI) {
      this.files.push(fileURI);
    },
    removedPhoto(id) {
      this.files = this.files.filter((item) => item !== id);
    },
    async createNewReview() {
      this.$v.rating.$touch();
      this.$v.body.$touch();

      if(this.$v.body.$invalid || this.$v.rating.$invalid) return;

      const payload = {
        object_code: this.itemCode,
        object_type: this.itemType,
        rating: this.rating,
        pros: this.pros,
        body: this.body,
        cons: this.cons,
      };

      const formDataPayload = new FormData();

      Object.entries(payload).forEach(([key, value]) => {
        formDataPayload.append(key, value);
      })

      this.files.forEach(item => formDataPayload.append('files[]', item.file))

      try {
        await this.createReview({
          type: this.itemType,
          code: this.itemCode,
          formData: formDataPayload,
        })


        this.body = ''
        this.rating = null
        this.pros = ''
        this.cons = ''
        this.files = []
        this.$emit('close');
      } catch(err) {
        this.$emit('error', err.message);
      }

    },
  },
};
